module.exports = __webpack_public_path__ + "static/media/mash_tun_banner.11e6049e.jpg";